import { styled } from 'styled-components'
import { SingleButtonModal } from '../shared/Modal'

interface Props {
    handleCancel: () => void
}

export default function ScoringModal({ handleCancel }: Props) {
    return (
        <SingleButtonModal
            children={<ScoringModalContent />}
            onCancel={handleCancel}
        />
    )
}

const Wrapper = styled.div`
    width: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f7f8fa;
    padding: 20px;
`

function ScoringModalContent() {
    return (
        <Wrapper>
            <p>How does the system calculate the scores?</p>
            <img src="/images/report/scoring.png" />
            <p>
                The total score is the number of criteria that the student
                demonstrated in each skill.
            </p>
            <div>
                Each skill is assessed on three to five specific performance
                criteria per skill; and scored 1 or 0 based on whether the
                criterion was fulfilled or not. The higher the score the more
                proficient the performance.
            </div>
        </Wrapper>
    )
}
